import stringify from 'fast-json-stable-stringify';
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export var hashKey = function (object) { return stringify(object); };
